
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'PackageIncludeModalTemplate',
  props: {
    packageName: {
      type: String,
      required: true,
    },
  },
  setup(_, context) {
    const closeModal = () => {
      context.emit('close');
    };

    return {
      closeModal,
    };
  },
});
